import React from 'react';
import { Box, Typography } from '@mui/material';
import CustomModal from '../../../../shared/CustomModal/CustomModal';
import CustomCard from '../../../../shared/CustomCard/CustomCard';
import CustomButton from '../../../../shared/CustomButton/CustomButton';
import zeplinColor from '../../../../../theme/Color';

interface ApiConfirmationModalProps {
  open: boolean;
  integrationName: string;
  isEnabling: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const ApiConfirmationModal: React.FC<ApiConfirmationModalProps> = ({
  open,
  integrationName,
  isEnabling,
  onConfirm,
  onCancel,
  loading = false,
}) => {
  return (
    <CustomModal handleClose={onCancel} open={open}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <CustomCard
          styles={{
            borderRadius: '14px',
            padding: { xs: '20px', xl: '24px' },
            backgroundColor: zeplinColor.Neutral1,
            width: '375px',
            boxShadow: 'rgba(0, 0, 0, 0.15)',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
              {isEnabling ? `Enable ${integrationName} API?` : `Disable ${integrationName} API?`}
            </Typography>

            <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
              {isEnabling ? (
                <>
                  This will enable the API connection for{' '}
                  <Typography
                    variant='responsiveBody3'
                    component='span'
                    color={zeplinColor.BasicBlack}
                    fontWeight={600}
                  >
                    {integrationName}
                  </Typography>{' '}
                  and start all active data sync and workflows. Are you sure you want to enable?
                </>
              ) : (
                <>
                  This will disable the API connection for{' '}
                  <Typography
                    variant='responsiveBody3'
                    component='span'
                    color={zeplinColor.BasicBlack}
                    fontWeight={600}
                  >
                    {integrationName}
                  </Typography>{' '}
                  and stop all active data sync and workflows. Are you sure you want to disable?
                </>
              )}
            </Typography>

            <Box
              sx={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '8px' }}
            >
              <CustomButton
                disabled={loading}
                onClick={onCancel}
                variant='outlined'
                color='primary'
                style={{
                  borderRadius: '8px',
                  height: '40px',
                  padding: '8px 16px',
                  flex: 1,
                  border: `1px solid ${zeplinColor.BasicBlack}`,
                  '&.hover': {
                    backgroundColor: zeplinColor.Neutral3,
                  },
                }}
                textStyle={{ color: zeplinColor.BasicBlack }}
                text='Cancel'
              />
              <CustomButton
                disabled={loading}
                onClick={onConfirm}
                variant='contained'
                color='primary'
                style={{
                  borderRadius: '8px',
                  height: '40px',
                  padding: '8px 16px',
                  backgroundColor: loading ? zeplinColor.Neutral3 : zeplinColor.Brand1,
                  flex: 1,
                }}
                textStyle={{ color: zeplinColor.Neutral1 }}
                text={loading ? 'Saving...' : 'Yes'}
              />
            </Box>
          </Box>
        </CustomCard>
      </Box>
    </CustomModal>
  );
};

export default ApiConfirmationModal;
